/* EQ sitewide opt-in background music (single track, looped with a ~1.5s fade-out / fade-in at the seam).
   - Nothing loads until the visitor presses SOUND ON, or turned it on earlier this session (sessionStorage).
   - sessionStorage keeps on/off + currentTime so the next page resumes near the same point.
   - Never starts on a first visit. If a browser blocks a resume, the button shows TAP TO RESUME.
   - Independent of the hero video loop. */
(function(){
  var K='eqHeroMusic',KT='eqHeroMusicT',SEAM=1.5,TARGET=0.6;
  function ss(k,v){try{if(v===undefined)return sessionStorage.getItem(k);sessionStorage.setItem(k,v)}catch(e){return null}}
  function init(btn){
    var src=btn.getAttribute('data-src');if(!src)return;
    var a=null,on=false,pending=false,seaming=false,fT=null;
    var lbl=btn.querySelector('.eq-snd__lbl');
    var reduce=window.matchMedia&&matchMedia('(prefers-reduced-motion: reduce)').matches;
    function ui(){
      btn.setAttribute('aria-pressed',on?'true':'false');
      btn.setAttribute('aria-label',on?'Turn background music off':(pending?'Tap to resume background music':'Turn background music on'));
      lbl.textContent=on?'SOUND OFF':(pending?'TAP TO RESUME':'SOUND ON');
      btn.classList.toggle('is-on',on);btn.classList.toggle('is-pending',pending&&!on);
    }
    function fade(to,ms,done){clearInterval(fT);if(!ms){a.volume=to;done&&done();return;}var from=a.volume,t0=performance.now();fT=setInterval(function(){var p=Math.min(1,(performance.now()-t0)/ms);a.volume=Math.max(0,Math.min(1,from+(to-from)*p));if(p>=1){clearInterval(fT);done&&done();}},40);}
    function ensure(){
      if(a)return a;a=document.createElement('audio');a.preload='none';a.loop=false;a.src=src;a.volume=0;
      a.addEventListener('timeupdate',function(){if(on&&!seaming&&a.duration&&a.duration-a.currentTime<=SEAM){seaming=true;fade(0,(a.duration-a.currentTime)*1000);}});
      a.addEventListener('ended',function(){if(!on){seaming=false;return;}try{a.currentTime=0}catch(e){}a.play().catch(function(){});fade(TARGET,SEAM*1000,function(){seaming=false;});});
      btn.parentNode.appendChild(a);return a;
    }
    function save(){if(a&&on)ss(KT,String(a.currentTime||0));}
    function start(t,ms){
      ensure();a.volume=0;seaming=false;
      if(t){var go=function(){try{if(a.duration&&t<a.duration-SEAM)a.currentTime=t}catch(e){}};if(a.readyState>=1)go();else a.addEventListener('loadedmetadata',go,{once:true});}
      var p=a.play();on=true;pending=false;ui();ss(K,'on');
      if(p&&p.catch)p.catch(function(){on=false;pending=true;ui();arm();});
      fade(TARGET,reduce?0:ms);
    }
    function stop(){on=false;pending=false;ui();ss(K,'off');ss(KT,'0');if(a)fade(0,reduce?0:700,function(){a.pause();});}
    function savedT(){return parseFloat(ss(KT))||0}
    var armed=false;
    function arm(){if(armed)return;armed=true;
      var go=function(ev){if(btn.contains(ev.target))return;off();if(!on)start(savedT(),900);};
      var off=function(){armed=false;['pointerdown','keydown','touchstart'].forEach(function(t){document.removeEventListener(t,go,true)});};
      ['pointerdown','keydown','touchstart'].forEach(function(t){document.addEventListener(t,go,{capture:true,passive:true})});}
    btn.addEventListener('click',function(e){e.stopPropagation();if(on)stop();else if(pending)start(savedT(),900);else start(0,1500);});
    document.addEventListener('visibilitychange',function(){if(!a)return;if(document.hidden){save();if(on){clearInterval(fT);a.pause();}}else if(on){a.volume=TARGET;a.play().catch(function(){});}});
    window.addEventListener('pagehide',save);setInterval(save,2000);
    ui();
    if(ss(K)==='on'){
      if(reduce){pending=true;ui();arm();}   /* reduced motion: never start without a gesture */
      else start(savedT(),900);               /* opted in earlier this session; blocked -> TAP TO RESUME */
    }
  }
  function boot(){document.querySelectorAll('[data-eq-snd]').forEach(init);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
})();
